import get from 'lodash.get';

// Store
import Global from '../../../store/global-selectors';
import * as JobPipelineActions from '../../../store/job-pipeline/job-pipeline.actions';

export const VoidResponseStep = (state, jobId) => {
  const { voidMessages } = Global.selectJobPipelineJobDataByJobId(state, {
    jobId,
  });

  const messagesByOutcome = voidMessages.reduce(
    (dict, message) => {
      let fulfillmentId = get(message, 'fulfillmentId');
      if (!fulfillmentId) {
        fulfillmentId = get(message, 'FillId');
      }
      if (fulfillmentId) {
        const voided = get(message, 'voided', false);
        const key = voided ? 'voided' : 'warned';
        const fulfillment = Global.selectEntitiesFulfillmentById(state, {
          fulfillmentId,
        });
        const trackingInformation = get(fulfillment, 'trackingInformation', {});
        dict[key].push({
          message,
          fulfillment,
          trackingInformation,
          voided,
        });
      }
      return dict;
    },
    { voided: [], warned: [] },
  );
  const { voided: successfullyVoided, warned: voidWarnings } = messagesByOutcome;

  return [JobPipelineActions.updateJob(jobId, { successfullyVoided, voidWarnings }), JobPipelineActions.goForwardOnJob(jobId)];
};
